export class PlusException {
    error_code: string;
    description: string;
    body: object;

    constructor(desc = null, code = null, body = {}) {
        this.error_code = code || 'PLUS_ERROR';
        this.description = desc || 'Ocurrió un error al intentar procesar la acción solicitada.';
        this.body = body;
    }
}